import React from 'react'
import { Grid } from '@chakra-ui/react'
import type { GridProps } from '@chakra-ui/react'

import Pagination from '../pagination'
import type { PageActions } from './types'
import SharedSearchBar from '../search-bar'

export default function PageActionBar({
    search,
    pagination,
    actions,
    gridOverrides,
}: PageActions) {
    const actionCount =
        (actions?.length ?? 0) + (!!pagination ? 1 : 0) + (!!search ? 1 : 0)

    return (
        <Grid
            mt={4}
            gridTemplateColumns={{
                base: '1fr',
                lg: getActionLayout(!!search, actionCount),
            }}
            flexWrap="wrap"
            gridGap={2}
            {...gridOverrides}
        >
            {search && (
                <SharedSearchBar
                    placeholder={search.placeholder}
                    value={search.query}
                    onChange={e => {
                        search.setQuery(e.target.value)
                        pagination?.setPage(0)
                    }}
                />
            )}
            {actions?.map((a, index) => (
                <React.Fragment key={index}>{a}</React.Fragment>
            ))}
            {pagination && <Pagination {...pagination} />}
        </Grid>
    )
}

function getActionLayout(hasSearch: boolean, actionCount: number = 0): string {
    return `${hasSearch ? 'auto' : 'fit-content(100%)'}${' fit-content(100%)'.repeat(actionCount)}`
}
